export const getNextUntitledFileName = (existingFiles, extension = ".pdf") => {
  const escapedExt = extension.replace(".", String.raw`\.`);
  const untitledPattern = new RegExp(`^Untitled(?:\\d+)?${escapedExt}$`);
  let maxNumber = 0;
  for(const name of existingFiles){
    const match = name.match(untitledPattern); // simplified
    if (match) {
      const numberMatch = name.match(/\d+/); // extract just the number
      const num = numberMatch ? Number.parseInt(numberMatch[0], 10) : 0;
      if (num >= maxNumber) {
        maxNumber = num + 1;
      }
    }
  };

  return maxNumber === 0 ? `Untitled${extension}` : `Untitled${maxNumber}${extension}`;
};

export const getNextUntitledFolderName = (existingNames) => {
  const untitledPattern = /^Untitled Folder(?:\d+)?$/;
  let maxNumber = 0;

  for (const name of existingNames){
    const match = name.match(untitledPattern);
    if (match) {
      const numberMatch = name.match(/\d+/);
      const num = numberMatch ? Number.parseInt(numberMatch[0], 10) : 0;
      if (num >= maxNumber) {
        maxNumber = num + 1;
      }
    }
  };

  return maxNumber === 0 ? "Untitled Folder" : `Untitled Folder${maxNumber}`;
};
